// extracted by mini-css-extract-plugin
export default {"indicator":"staging-indicator_indicator__UB0Ws"};